import type {ColorMap} from '@pinecast/styles';

/** The look of `PageHeader` and `DesktopPageHeader`. */
export const pageHeaderStyles = (designColors: ColorMap) => ({
  color: designColors.headingBlue,
  display: 'block',
  fontSize: 24,
  fontFamily: 'Monument Grotesk Bold',
  fontWeight: 400,
  lineHeight: 28,
  marginBottom: 12,
  marginTop: 0,
  ':not(:empty) ~ .PageSubheader': {
    marginTop: 20,
  },
});
